module.exports = __webpack_public_path__ + "static/media/velma-lose.7bbbe34d.png";